import axios from "axios";

//const API_URL = "/api/auth/";
//const API_URL = "http://localhost:8080/api/auth/";
const API_URL = process.env.REACT_APP_API_URL + "api/auth/";
class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "signin", {
        username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("ktas01.user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("ktas01.user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('ktas01.user'));;
  }
}

//export default new AuthService();
const authService = new AuthService();
export default authService;